/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class MinimumAmountField extends PureComponent {
  render() {
    const { onChange, value } = this.props

    return (
      <Form.Field required>
        <label>Minimum Amount</label>
        <Input
          labelPosition="right"
          placeholder="e.g 10"
          type="number"
          onChange={e => onChange(e.target.value)}
          value={value}
          required
          min={0}
        />
      </Form.Field>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/promotions/fields/minimumAmountField.js